<template>
    <div class="n2-center-container">
        <p>Sign-in in progress</p>
    </div>
</template>

<script>
    //import store from '../store';
    import { mapState } from 'vuex';

    export default {
        computed: mapState({
            return_url: state => state.identity.sign_in_return_url,
        }),
        async created() {
            try {
                await this.$store.dispatch('identity/sign_in_callback');
                var returnToUrl = '/';
                if (this.return_url) {
                    returnToUrl = this.return_url;
                }
                this.$router.push({ path: returnToUrl });
            } catch (e) {
                this.$router.push({ name: 'unauthorized' });
            }
        }
        //created() {

        //    this.$store.dispatch('identity/sign_in_callback').then(() => {
        //        var returnToUrl = '/';
        //        if (this.return_url) {
        //            returnToUrl = this.return_url;
        //        }
        //        this.$router.push({ path: returnToUrl });
        //    });
        //}
    }
</script>